<script setup lang="ts">
const route = useRoute()
const chromeLayout = computed(() => route.meta.platformChromeLayout ?? 'wide')
const { data: config } = useMorningConfig()
const { selectedTheme, cycleTheme } = useAppearance(
  () => config.value?.app.appearance.theme ?? 'auto',
  () => config.value?.app.appearance.accent ?? '#1677e8',
)
</script>

<template>
  <UiTopbar
    class="platform-topbar"
    :data-layout="chromeLayout"
    aria-label="En-tête de la plateforme"
  >
    <div class="platform-topbar__inner">
      <DashboardBrandRow
        :name="config?.app.name ?? 'Morning'"
        :logo="config?.app.branding.logo ?? '/morning-mark.svg'"
        :locale="config?.app.locale ?? 'fr-FR'"
        :show-date="config?.app.header.showDate ?? true"
        :theme="selectedTheme"
        @cycle-theme="cycleTheme"
      />
    </div>
  </UiTopbar>
</template>
